import { useEffect, useState } from "react";
import { getProductTypesAll } from "../api";
import {
  Code,
  Container,
  Table,
  TextInput,
  Title,
  Group,
  Badge,
  ActionIcon,
  Tooltip,
} from "@mantine/core";
import Timeago from "../../../Boilerplate/_Shared/Timeago";
import { useLocation } from "wouter";
import { IconEdit, IconEye } from "@tabler/icons-react";
import { useStore } from "../store";

export default function List({ params }) {
  const [productTypes, setProductTypes] = useState([]);
  const [filter, setFilter] = useState("");
  const [, setLocation] = useLocation();
  const profile = useStore((state) => state.profile);

  useEffect(() => {
    getProductTypesAll(params.marketplaceId).then((data) => {
      setProductTypes(data); // data.data
    });
  }, []);

  const filteredData =
    productTypes?.data?.filter(
      (productType) =>
        productType.code.includes(filter) ||
        productType.label.includes(filter) ||
        productType.id.includes(filter)
    ) ?? [];

  return (
    <Container size="xl">
      <Title order={1}>Product Types</Title>

      <TextInput
        placeholder="Filter"
        onChange={(event) => setFilter(event.currentTarget.value)}
        value={filter}
      />
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Id</Table.Th>
            <Table.Th>Level</Table.Th>
            <Table.Th>Code</Table.Th>
            <Table.Th>Label</Table.Th>
            <Table.Th>Last Fetched</Table.Th>
            <Table.Th>Overrides</Table.Th>
            {profile?.role === "GlobalAdmin" && <Table.Th>Actions</Table.Th>}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {filteredData.map((productType) => (
            <Table.Tr
              onClick={() =>
                setLocation(
                  `/marketplaces/${
                    productType.marketplaceId ?? params.marketplaceId
                  }/types/${productType.id}`
                )
              }
              key={productType.id}
            >
              <Table.Td>{productType.id}</Table.Td>
              <Table.Td>{productType.level}</Table.Td>
              <Table.Td>{productType.code}</Table.Td>
              <Table.Td>{productType.label}</Table.Td>
              <Table.Td>
                <Timeago date={productType.lastFetched} />
              </Table.Td>
              <Table.Td>
                {profile?.role === "GlobalAdmin" ? (
                  <Badge color="blue" variant="light" size="xs">
                    Check Details
                  </Badge>
                ) : (
                  <Badge color="gray" variant="light" size="xs">
                    N/A
                  </Badge>
                )}
              </Table.Td>
              {profile?.role === "GlobalAdmin" && (
                <Table.Td style={{ width: 0, whiteSpace: "nowrap" }}>
                  <Group wrap="nowrap" gap={4}>
                    <Tooltip label="View/Edit Details">
                      <ActionIcon
                        variant="subtle"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          setLocation(
                            `/marketplaces/${
                              productType.marketplaceId ?? params.marketplaceId
                            }/types/${productType.id}`
                          );
                        }}
                      >
                        <IconEdit size="1rem" />
                      </ActionIcon>
                    </Tooltip>
                  </Group>
                </Table.Td>
              )}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>

      <div>
        {productTypes?.data?.map((productType) => (
          <Code block key={productType.id}>
            {JSON.stringify(productType, null, 2)}
          </Code>
        ))}
      </div>
    </Container>
  );
}
